import { render, staticRenderFns } from "./connectwise-send-contact-widget.vue?vue&type=template&id=2ecba84d&scoped=true&"
import script from "./connectwise-send-contact-widget.vue?vue&type=script&lang=js&"
export * from "./connectwise-send-contact-widget.vue?vue&type=script&lang=js&"
import style0 from "./connectwise-send-contact-widget.vue?vue&type=style&index=0&id=2ecba84d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecba84d",
  null
  
)

export default component.exports